"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));

var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));

var _PassengerSelectionStepper = _interopRequireDefault(require("@airasia/phoenix-components/components/PassengerSelectionStepper"));

var _Checkbox = _interopRequireDefault(require("@airasia/phoenix-components/components/Checkbox"));

var _Title = _interopRequireDefault(require("@airasia/phoenix-components/components/Title"));

var _SectionTileGroup = _interopRequireDefault(require("@airasia/phoenix-components/components/SectionTileGroup"));

var _TextField = _interopRequireDefault(require("@airasia/phoenix-components/components/TextField"));

var _Modal = _interopRequireDefault(require("@airasia/phoenix-components/components/Modal"));

var _Banner = _interopRequireDefault(require("../Banner"));

var _Button = _interopRequireDefault(require("@airasia/phoenix-components/components/Button"));

var _utilities = _interopRequireDefault(require("../../utilities"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _constant = require("../constant");

var _constant2 = require("@airasia/phoenix-components/components/JourneyPriceCTA/constant");

var _flightPassengerSelector = _interopRequireDefault(require("./flightPassengerSelector.proptypes"));

var _constant3 = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var FlightPaxSelectorContainer = _styledComponents.default.div.withConfig({
  displayName: "FlightPassengerSelector__FlightPaxSelectorContainer",
  componentId: "sc-1iqq6ke-0"
})(["position:relative;#flight-passenger-selector-modal{#airasia-phoenix-modal-footer{justify-content:flex-end;}}"]);

var PaxSelectorDropdownLabelContainer = _styledComponents.default.div.withConfig({
  displayName: "FlightPassengerSelector__PaxSelectorDropdownLabelContainer",
  componentId: "sc-1iqq6ke-1"
})(["display:inline-flex;align-items:center;cursor:pointer;"]);

var DropdownIcon = _styledComponents.default.div.withConfig({
  displayName: "FlightPassengerSelector__DropdownIcon",
  componentId: "sc-1iqq6ke-2"
})(function (_ref) {
  var theme = _ref.theme;
  return "\n        margin-right: ".concat(theme.space.micro, ";\n        line-height: 0;\n    ");
});

var DropdownActionIcon = _styledComponents.default.div.withConfig({
  displayName: "FlightPassengerSelector__DropdownActionIcon",
  componentId: "sc-1iqq6ke-3"
})(function (_ref2) {
  var theme = _ref2.theme;
  return "\n        margin-left: ".concat(theme.space.XXSmall, ";\n        line-height: 0;\n    ");
});

var PaxSelectorDropdownContainer = _styledComponents.default.div.withConfig({
  displayName: "FlightPassengerSelector__PaxSelectorDropdownContainer",
  componentId: "sc-1iqq6ke-4"
})(function (_ref3) {
  var theme = _ref3.theme,
      move = _ref3.move;
  return "\n        position: absolute;\n        z-index: 15;\n        background: ".concat(theme.backgroundColor.default, ";\n        width: 360px;\n        // max-height: 489px;\n        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);\n        border-radius: ").concat(move ? theme.borderRadius.XXnormal : theme.borderRadius.normal, ";\n        padding: ").concat(theme.space.standard, " ").concat(theme.space.small, ";\n\n        #flight-pax-selector-travel-class{\n          h3 {\n            font-size: ").concat(theme.fontSize.small, ";\n            margin-bottom: ").concat(theme.space.tiny, ";\n          }\n          [role=\"listitem\"]{\n            padding:  ").concat(theme.space.XSmall, ";\n            p {\n              font-size: ").concat(theme.fontSize.small, ";\n            }\n          }\n        }\n    ");
});

var Divider = _styledComponents.default.div.withConfig({
  displayName: "FlightPassengerSelector__Divider",
  componentId: "sc-1iqq6ke-5"
})(function (_ref4) {
  var theme = _ref4.theme;
  return "\n        height: 1px;\n        background: ".concat(theme.colors.greyMedium, ";\n        margin: ").concat(theme.space.small, " 0;\n    ");
});

var MixTravelClassContainer = _styledComponents.default.div.withConfig({
  displayName: "FlightPassengerSelector__MixTravelClassContainer",
  componentId: "sc-1iqq6ke-6"
})(["display:flex;& > div{margin:auto;}"]);

var MixTravelClassLabel = _styledComponents.default.div.withConfig({
  displayName: "FlightPassengerSelector__MixTravelClassLabel",
  componentId: "sc-1iqq6ke-7"
})(["flex:7;"]);

var MixTravelTitle = (0, _styledComponents.default)(_Title.default).withConfig({
  displayName: "FlightPassengerSelector__MixTravelTitle",
  componentId: "sc-1iqq6ke-8"
})(function (_ref5) {
  var theme = _ref5.theme;
  return "\n    font-size: ".concat(theme.fontSize.normal, ";\n  ");
});
var MixTravelClassCheckbox = (0, _styledComponents.default)(_Checkbox.default).withConfig({
  displayName: "FlightPassengerSelector__MixTravelClassCheckbox",
  componentId: "sc-1iqq6ke-9"
})(["flex:1;"]);

var formatTravelClassConfig = function formatTravelClassConfig(config) {
  if (!config) {
    return [];
  }

  return config.map(function (c) {
    return {
      title: c.title,
      value: c.value,
      alignCenter: true,
      borderColor: 'greyLight'
    };
  });
};

var formatSelectorTitle = function formatSelectorTitle(text, count, travelClass) {
  if (!text) {
    return '';
  }

  return text.replace('{{count}}', count).replace('{{travelClass}}', travelClass);
};

var getTravelClassTitle = function getTravelClassTitle(tcArray, value) {
  if (!tcArray || !value) {
    return '';
  }

  var element = tcArray.find(function (tc) {
    return tc.value === value;
  });

  if (!element) {
    return '';
  }

  return element.title;
};

var FlightPassengerSelector = function FlightPassengerSelector(props) {
  var passengerStepperConfig = props.passengerStepperConfig,
      travelClassConfig = props.travelClassConfig,
      translations = props.translations,
      onDone = props.onDone,
      defaultTravelClass = props.defaultTravelClass,
      isMixTravelClass = props.isMixTravelClass,
      showTravelClass = props.showTravelClass,
      showMixClassCheckbox = props.showMixClassCheckbox,
      isMobile = props.isMobile,
      theme = props.theme,
      accessible = props.accessible,
      customProperties = props.customProperties,
      hasBanner = props.hasBanner,
      bannerData = props.bannerData;

  var alltranslations = _objectSpread(_objectSpread({}, _constant3.DEFAULT_TRANSLATIONS), translations);

  var flightPaxSelectorTitle = alltranslations.flightPaxSelectorTitle,
      flightPaxSelectorWithTravelClassTitle = alltranslations.flightPaxSelectorWithTravelClassTitle,
      mixTravelTitle = alltranslations.mixTravelTitle,
      mixTravelSubtitle = alltranslations.mixTravelSubtitle,
      doneButtonLabel = alltranslations.doneButtonLabel,
      flightPaxSelectorMainTitle = alltranslations.flightPaxSelectorMainTitle,
      travelClassTitle = alltranslations.travelClassTitle;
  var tabIndex = !accessible ? '-1' : '0';

  var _useState = (0, _react.useState)(formatTravelClassConfig(travelClassConfig)),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      formattedTravelClass = _useState2[0],
      setFormattedTravelClass = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      dropdownOpen = _useState4[0],
      setDropdownOpen = _useState4[1];

  var _useState5 = (0, _react.useState)(isMixTravelClass),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      isMixClass = _useState6[0],
      setIsMixClass = _useState6[1];

  var _useState7 = (0, _react.useState)(passengerStepperConfig.passengerCount || _constant3.DEFAULT_PASSENGER_STEPPER_CONFIG.passengerCount),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      paxCount = _useState8[0],
      setPaxCount = _useState8[1];

  var _useState9 = (0, _react.useState)(defaultTravelClass),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      travelClass = _useState10[0],
      setTravelClass = _useState10[1];

  var _useState11 = (0, _react.useState)(formatSelectorTitle(showTravelClass ? flightPaxSelectorWithTravelClassTitle.single : flightPaxSelectorTitle.single, 1, getTravelClassTitle(travelClassConfig, travelClass))),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      formattedSelectorTitle = _useState12[0],
      setFormattedSelectorTitle = _useState12[1];

  var paxSelectorDropdownRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (!showTravelClass) {
      return;
    }

    setFormattedTravelClass(formatTravelClassConfig(travelClassConfig));
  }, [travelClassConfig, showTravelClass]);
  (0, _react.useEffect)(function () {
    if (!showTravelClass) {
      return;
    }

    if (travelClass !== defaultTravelClass) {
      setTravelClass(defaultTravelClass);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [defaultTravelClass]);
  (0, _react.useEffect)(function () {
    setPaxCount(passengerStepperConfig.passengerCount || _constant3.DEFAULT_PASSENGER_STEPPER_CONFIG.passengerCount);
  }, [passengerStepperConfig]);

  var paxSelectorOnClickHandler = function paxSelectorOnClickHandler() {
    setDropdownOpen(!dropdownOpen);
  };

  var mixTravelClassHandler = function mixTravelClassHandler() {
    setIsMixClass(!isMixClass);
  };

  var onPaxSelectorClose = function onPaxSelectorClose() {
    setDropdownOpen(false);
    var defaultObject = {
      paxCount: paxCount
    };

    if (showTravelClass) {
      defaultObject = _objectSpread(_objectSpread({}, defaultObject), {}, {
        travelClass: travelClass
      });
    }

    if (showMixClassCheckbox) {
      defaultObject = _objectSpread(_objectSpread({}, defaultObject), {}, {
        mixedTravelClass: isMixClass
      });
    }

    onDone(defaultObject);
  };

  var paxStepperClickedHandler = function paxStepperClickedHandler(data) {
    setPaxCount(data);
  };

  var travelClassHandler = function travelClassHandler(data) {
    setTravelClass(data);
  };

  (0, _react.useEffect)(function () {
    if (!showTravelClass) {
      setTravelClass(defaultTravelClass);
    }
  }, [showTravelClass, defaultTravelClass]);
  (0, _react.useEffect)(function () {
    var sum = 0; // eslint-disable-next-line no-restricted-syntax

    for (var el in paxCount) {
      // eslint-disable-next-line no-prototype-builtins
      if (paxCount.hasOwnProperty(el)) {
        sum += parseFloat(paxCount[el]);
      }
    }

    var translationObj = flightPaxSelectorWithTravelClassTitle;
    var title = sum > 1 ? translationObj.plural : translationObj.single;
    var travelClassTitleTemp = getTravelClassTitle(travelClassConfig, travelClass);
    setFormattedSelectorTitle(formatSelectorTitle(title, sum, travelClassTitleTemp));
  }, [flightPaxSelectorTitle, flightPaxSelectorWithTravelClassTitle, paxCount, travelClass, travelClassConfig, showTravelClass]);

  _utilities.default.useOutsideClickHandler(paxSelectorDropdownRef, onPaxSelectorClose);

  var onModalClose = function onModalClose() {
    setDropdownOpen(false);
  };

  var flightPaxSelectorContent = function flightPaxSelectorContent() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_PassengerSelectionStepper.default, {
      accessible: false,
      stepperClicked: paxStepperClickedHandler,
      theme: theme,
      data: _objectSpread(_objectSpread({}, passengerStepperConfig), {}, {
        passengerCount: paxCount
      })
    }), showTravelClass && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Divider, null), /*#__PURE__*/_react.default.createElement(_SectionTileGroup.default, {
      title: travelClassTitle,
      data: formattedTravelClass,
      numOfCol: "2",
      defaultSelectedData: travelClass,
      onClick: travelClassHandler,
      enableHover: false,
      theme: theme,
      customProperties: {
        id: 'flight-pax-selector-travel-class'
      }
    })), hasBanner && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Divider, null), /*#__PURE__*/_react.default.createElement(_Banner.default, {
      imageURL: bannerData && bannerData.imageURL,
      theme: theme,
      tags: bannerData && bannerData.tags,
      subheadline: bannerData && bannerData.subheadline,
      headline: bannerData && bannerData.headline,
      newBanner: true
    })), showMixClassCheckbox && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Divider, null), /*#__PURE__*/_react.default.createElement(MixTravelClassContainer, null, /*#__PURE__*/_react.default.createElement(MixTravelClassLabel, null, /*#__PURE__*/_react.default.createElement(MixTravelTitle, {
      type: "h3"
    }, mixTravelTitle), /*#__PURE__*/_react.default.createElement(_Text.default, {
      type: "small",
      theme: theme
    }, mixTravelSubtitle)), /*#__PURE__*/_react.default.createElement(MixTravelClassCheckbox, {
      isSelected: isMixClass,
      onChange: mixTravelClassHandler,
      customProperties: {
        id: 'test'
      }
    }))));
  };

  var flightPaxSelectorFooter = /*#__PURE__*/_react.default.createElement(_Button.default, {
    backgroundColor: "primary",
    color: "default",
    theme: theme,
    handleClick: onPaxSelectorClose
  }, doneButtonLabel);

  var getMain = function getMain() {
    var move = theme === _constant2.THEMES.MOVE;
    return /*#__PURE__*/_react.default.createElement(FlightPaxSelectorContainer, (0, _extends2.default)({
      isMobile: isMobile,
      accessible: true,
      onBlur: function onBlur(e) {
        return _utilities.default.outsideOfParent(e, paxSelectorDropdownRef, paxSelectorOnClickHandler);
      }
    }, customProperties), !isMobile ? /*#__PURE__*/_react.default.createElement(PaxSelectorDropdownLabelContainer, {
      id: "home_paxdetails",
      tabIndex: tabIndex,
      onClick: paxSelectorOnClickHandler,
      onKeyDown: function onKeyDown(e) {
        return _utilities.default.keyDownHandler(e, paxSelectorOnClickHandler, _constant.KEY_CODE.ENTER);
      }
    }, /*#__PURE__*/_react.default.createElement(DropdownIcon, {
      id: "airasia-dropdown-options-left-icon"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      fontsize: "normal",
      accessible: false,
      icon: "Person",
      color: "greyDark",
      theme: theme
    })), /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: false,
      theme: theme,
      customProperties: {
        id: 'airasia-dropdown-options-title',
        'aria-hidden': 'false'
      }
    }, formattedSelectorTitle), /*#__PURE__*/_react.default.createElement(DropdownActionIcon, {
      id: "airasia-dropdown-options-right-icon"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: false,
      fontsize: "titleNormal",
      icon: "ArrowDropDownIcon",
      color: "greyDark",
      theme: theme
    }))) : /*#__PURE__*/_react.default.createElement(_TextField.default, {
      accessible: true,
      alwaysShowLabel: false,
      icon: "ExpandMoreIcon",
      label: flightPaxSelectorMainTitle,
      onBlur: function onBlur() {},
      onChange: function onChange() {},
      onFocus: paxSelectorOnClickHandler,
      showIcon: true,
      theme: theme,
      type: "text",
      value: formattedSelectorTitle,
      customProperties: {
        readOnly: true
      }
    }), dropdownOpen && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !isMobile ? /*#__PURE__*/_react.default.createElement(PaxSelectorDropdownContainer, {
      ref: paxSelectorDropdownRef,
      move: move
    }, flightPaxSelectorContent()) : /*#__PURE__*/_react.default.createElement(_Modal.default, {
      openModal: dropdownOpen,
      onClose: onModalClose,
      fullScreen: true,
      zIndex: 12,
      title: flightPaxSelectorMainTitle,
      theme: theme,
      viewPort: "mobile",
      footerContent: flightPaxSelectorFooter,
      customProperties: {
        id: 'flight-passenger-selector-modal'
      }
    }, flightPaxSelectorContent())));
  };

  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

FlightPassengerSelector.propTypes = _flightPassengerSelector.default.PropTypes;
FlightPassengerSelector.defaultProps = _flightPassengerSelector.default.DefaultProps;
var _default = FlightPassengerSelector;
exports.default = _default;